import { removeConditionsTable } from "./remove_Conditions_Table_function";
import determinePossiblePurchases from "./determine_possible_purchases";


export const processEventChangesToConditionsTable = (conditionsTable, triggerCondName, duration, deleteCondName,
        deleteClass, eventConditions, purchaseArr, imageDir ) => {

    if (!conditionsTable){
        conditionsTable = []
    }

    // delete any conditions that have a class that matches the delete class on the event response
    // or if they have a condition name that matches the condition name on the event response
    if (deleteCondName && deleteCondName !== "") 
       {
        // going thru conditionsTable backwards as it is the only way that the delete works
        // else, the splice resets the index 
        let startIdx = conditionsTable.length - 1
        for (let i=startIdx; i>=0; i--){
            if (conditionsTable[i].condName === deleteCondName){
                conditionsTable.splice(i,1)
            }
        }
    }   
    if (deleteClass && deleteClass !== ""){
        conditionsTable = removeConditionsTable(conditionsTable, deleteClass);
    }

    // add conditions for no more purchases if there are no available purchases for this purchaseType (imageDir)
    let noMorePurchaseCondition = "";
    if (imageDir  && imageDir !== ""){
        let possiblePurchasesArr = JSON.parse(JSON.stringify(determinePossiblePurchases(purchaseArr,imageDir)));
        if (possiblePurchasesArr.length === 0){
            noMorePurchaseCondition = 
                        eventConditions.find(elem => elem.primaryFieldName === imageDir);
            let conditionObj = {condName: noMorePurchaseCondition.condName, 
                    conditionClass: noMorePurchaseCondition.conditionClass,
                            duration: -1 }
                    conditionsTable.push(conditionObj);
        }
    }
    if (triggerCondName && triggerCondName !== ""){
        if (duration <= 1){
            duration = -1;
        }
    // find the trigger condition on the conditions collection and add the condition that matches 
    // if it is not already on the conditionsTable
        let conditionFindObj = eventConditions.find(elem => elem.condName === triggerCondName);
        let conditionAlreadyThere = 
            conditionsTable.find(elem => elem.condName === triggerCondName);
        if (conditionFindObj  && conditionFindObj !== "" && 
            !conditionAlreadyThere){
                if (conditionFindObj.duration ){
                    duration = conditionFindObj.duration;
                }
                let skipEventCategory = undefined;
                if (conditionFindObj.skipEventCategory){
                    skipEventCategory = conditionFindObj.skipEventCategory
                }
                let conditionObj = {condName: conditionFindObj.condName, 
                    conditionClass: conditionFindObj.conditionClass,
                    duration: duration,
                    protectPlanType: conditionFindObj.protectPlanType,
                    iconName: conditionFindObj.iconName,
                    skipEventCategory: skipEventCategory }
                conditionsTable.push(conditionObj); 
        }
    }
                
    return conditionsTable;
   
}
